import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6c6df3b0"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotHome: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Templates/Home/Home.vue').default})
